import { apiClient } from '@/shared/lib/apiClient';
import type { AdminPaymentsListResponse, ListAdminPaymentsQuery } from '../types/adminPayment';

interface ApiResponse<T> {
  success: boolean;
  data: T;
}

export async function listAdminPayments(
  query?: ListAdminPaymentsQuery,
): Promise<AdminPaymentsListResponse> {
  const params: Record<string, string> = {};
  if (query?.cursor) params['cursor'] = query.cursor;
  if (query?.limit !== undefined) params['limit'] = String(query.limit);
  if (query?.status) params['status'] = query.status;
  if (query?.provider) params['provider'] = query.provider;
  if (query?.tenant_id) params['tenant_id'] = query.tenant_id;
  if (query?.product_id) params['product_id'] = query.product_id;
  if (query?.product_slug) params['product_slug'] = query.product_slug;
  if (query?.plan_id) params['plan_id'] = query.plan_id;
  if (query?.subscription_id) params['subscription_id'] = query.subscription_id;
  if (query?.search) params['search'] = query.search;
  if (query?.from) params['from'] = query.from;
  if (query?.to) params['to'] = query.to;

  const res = await apiClient.get<ApiResponse<AdminPaymentsListResponse>>(
    '/api/v1/admin/payments',
    { params },
  );
  return res.data;
}
